module.exports = __webpack_public_path__ + "static/media/knowledge_feature.1541a763.png";